<p>
  <ng-content></ng-content>
</p>
